"use client";
import React from "react";

function ButtonCommon({
  text,
  onClick,
}: {
  text: string;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      className="px-3 h-10 max-md:h-auto max-md:py-2 max-md:px-4 cursor-pointer bg-orange-400 rounded font-medium text-white text-[13px] max-md:text-[11px] flex items-center justify-center w-fit"
    >
      {text}
    </div>
  );
}

export default ButtonCommon;
